import { z } from 'zod';

const decimalString = z
  .union([z.string(), z.number()])
  .transform((value) => String(value))
  .refine((value) => /^-?\d+(\.\d+)?$/.test(value), 'invalidDecimal');

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'invalidDate');

export const CloseoutBatchResponseSchema = z.object({
  id: z.string(),
  batch_date: isoDate,
  status: z.string(),
  created_at: z.string(),
  completed_at: z.string().nullable(),
  total_deals_matched: z.number().int(),
  total_notional_compressed: decimalString,
});

export type CloseoutBatchResponse = z.infer<typeof CloseoutBatchResponseSchema>;

export const CloseoutBatchListSchema = z.array(CloseoutBatchResponseSchema);

export const CloseoutBatchFiltersSchema = z.object({
  date: isoDate.optional(),
});

export type CloseoutBatchFilters = z.infer<typeof CloseoutBatchFiltersSchema>;

export const CloseoutBatchesPayloadSchema = z.object({
  filters: CloseoutBatchFiltersSchema.optional(),
  selectedBatchId: z.string().optional(),
});

export type CloseoutBatchesPayload = z.infer<typeof CloseoutBatchesPayloadSchema>;
